import { render, staticRenderFns } from "./ElAlert.vue?vue&type=template&id=4a69aed0&scoped=true"
import script from "./ElAlert.vue?vue&type=script&lang=js"
export * from "./ElAlert.vue?vue&type=script&lang=js"
import style0 from "./ElAlert.vue?vue&type=style&index=0&id=4a69aed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a69aed0",
  null
  
)

export default component.exports